import {
    EditListPopup,
    PopupComponent,
    PopupElements
} from './edit-list-popup';
import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher';
import { initPersonContact } from './main';
import SearchFilter from './search-filter';
import { SortingList } from './sorting-list';

export default class PersonContact {
    init(): void {
        const popupElements: PopupElements = {
            addItemButton: document.querySelector('[data-action="AddContact"]'),
            editButtons: Array.from(
                document.querySelectorAll('[data-action="EditContact"]')
            ),
            deleteButtons: Array.from(
                document.querySelectorAll('[data-action="DeleteContact"]')
            )
        };

        const popupComponent: PopupComponent = {
            displayComponentName: 'CustomerContactForm',
            removeItemUrl: 'CustomerCenter/DeletePersonContact',
            addItemUrlParameters: [
                {
                    fieldName: 'personId',
                    dataAttributeTargetValue: 'data-person-id'
                }
            ],
            editItemUrlParameters: [
                {
                    fieldName: 'contactId',
                    dataAttributeTargetValue: 'data-contact-id'
                }
            ],
            removeItemUrlParameters: [
                {
                    fieldName: 'contactId',
                    dataAttributeTargetValue: 'data-contact-id'
                }
            ]
        };

        new EditListPopup().init(
            'ContactForm',
            'contact-form-popup',
            popupElements,
            popupComponent,
            () => this.reloadComponent(),
            () => this.reloadComponent()
        );

        const component = document.querySelector(
            '[data-component=CustomerPersonContacts]'
        );

        const personId = popupElements.addItemButton.getAttribute(
            'data-person-id'
        );
        const queryParams = { key: 'personId', value: personId };

        const filter = new SearchFilter(component, initPersonContact, [
            queryParams
        ]);
        new SortingList(component, initPersonContact, [queryParams], filter);
    }

    private reloadComponent(): void {
        const action = new ActionCreator().reloadComponent(
            'CustomerPersonContacts'
        );
        action.successAction = () => initPersonContact();

        new AjaxDispatcher().dispatchGetAction(action);
    }
}
